import * as React from 'react';
import { Box } from '@mui/material';
import { addIcon } from '@europrocurement/l2d-icons';
import { FlexyButton } from '@europrocurement/flexy-components';

export type DossierLegalAnnoucementsFooterProps = {
    canAddLegalAnnoucement: boolean;
    handleAddLegalAnnoucement: () => void;
};

const DossierLegalAnnoucementsFooter: React.FunctionComponent<DossierLegalAnnoucementsFooterProps> =
    function (props) {
        const { canAddLegalAnnoucement, handleAddLegalAnnoucement } = props;

        const wrapperSx = {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
        };

        const textBtnSx = {
            fontWeight: 500,
            padding: '8px 20px',
        };

        return (
            <Box sx={wrapperSx}>
                {canAddLegalAnnoucement && (
                    <FlexyButton
                        key="add-formality-btn"
                        variant="text"
                        label="Ajouter une annonce légale"
                        icon={addIcon}
                        onClick={handleAddLegalAnnoucement}
                        sx={textBtnSx}
                    />
                )}
            </Box>
        );
    };

export default DossierLegalAnnoucementsFooter;
